document.addEventListener("DOMContentLoaded", function () {
  const detailBtn = document.querySelector(".detail_btn");
  const detailSection = document.querySelector("#detail");

  if (detailBtn && detailSection) {
    detailBtn.addEventListener("click", function () {
      // #detailに-openクラスをつけ外し
      detailSection.classList.toggle("-open");
      // detail_btn自身にも-openクラスをつけ外し
      detailBtn.classList.toggle("-open");
    });
  }
});
